module.exports = __webpack_public_path__ + "img/employees@2x.15ba584.webp";